import {connect, useSelector} from "react-redux";
import React, {useCallback, useMemo, useRef, useState} from "react";
import * as api from "../../../../api/api";
import {Loading} from "../../../../components/common";
import {CAlert, CButton, CCol, CForm, CFormInput, CInputGroup, CInputGroupText, CRow} from "@coreui/react";
import {getMenuList, putMenu} from "../../../../api/api";
import {AgGridReact} from "ag-grid-react";

const MenuManage = (props) => {
	const {user} = useSelector((props) => props.account);
	const gridRef = useRef();
	const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);

	const [loading, setLoading] = useState(false);
	const [error, setError] = useState({visible: false, message: ""});
	const [rowData, setRowData] = useState([]);

	const defaultMenuData = {seq: -1, menuCd: "", menuNm: "", parentCd: "", menuPath: "", menuType: "", expandYn: "Y", sortOrder: 0, useYn: "Y", description: "", posType: "3"}
	const [selectedRow, setSelectedRow] = useState(defaultMenuData)

	const defaultColDef = {
		width: 100,
		resizable: true,
		sortable: true,
		filter: false,
		autoHeaderHeight: true
	};

	const [columnDefs] = useState([
		{field: "menuCd", headerName: "메뉴코드", resizable: false},
		{field: "menuNm", headerName: "메뉴명", flex: 1},
		{field: "menuPath", headerName: "메뉴경로", flex: 1},
		{field: "menuType", headerName: "메뉴권한", width: 70, resizable: false},
		{field: "description", headerName: "메뉴설명", flex: 1},
		{field: "sortOrder", headerName: "정렬순서", maxWidth: 50, cellClass: "static-cell"},
		{field: "useYn", headerName: "사용유무", maxWidth: 50, cellClass: "static-cell"},
	]);

	const init = () => {
		setSelectedRow(defaultMenuData);
	}

	const search = () => {
		setError({visible: false, message: ""});
		const params = {
			posType: "3"
		};
		console.log(">>> params :: ", params);

		setLoading(true);
		getMenuList(params).then((result) => {
			const {responseBody, responseCode, responseMessage} = result.data;
			if (responseCode === "200") {
				setRowData(responseBody);
			}
		})
			.finally(() => {
				setLoading(false);
			})
	}

	const save = () => {
		setError({visible: false, message: ""});
		if (confirm("저장하시겠습니까?")) {
			const params = {
				...selectedRow
			}
			params.instUser = params.instUser ? params.instUser : user.userId;
			params.updUser = user.userId;

			setLoading(true);
			putMenu(params).then((result) => {
				const {responseBody, responseCode, responseMessage} = result.data;
				if (responseCode === "200") {
					// 성공
					alert("정상적으로 처리되었습니다.");
					search();
				} else {
					setError({visible: true, message: responseMessage});
				}
			})
				.catch((error) => {
					console.log(">>> error :: ", error);
					setError({visible: true, message:  error.message})
				})
				.finally(() => {
					setLoading(false);
				})
		}
	}

	const onRowSelected = useCallback((event) => {
		if (!event.node.selected)
			return;
		setSelectedRow(event.node.data);
	}, []);

	return (
		<div style={containerStyle}>
			{loading ? <Loading/> : null}
			{error.visible ? <CAlert color="danger">{error.message}</CAlert> : null}
			<div className="d-grid gap-1 d-md-flex justify-content-between" style={{marginBottom: 10}}>
				<h5>메뉴 등록관리</h5>
				<div>
					<CButton className={"m-1"} size={"sm"} color="primary" onClick={init}>신규</CButton>
					<CButton size={"sm"} color="primary" onClick={search}>조회</CButton>
				</div>
			</div>
			<CRow>
				<CCol xs={7}>
					<div className="ag-theme-alpine" style={{width: "100%", height: 550}}>
						<AgGridReact
							rowSelection={"single"}
							onRowClicked={onRowSelected}
							headerHeight={30}
							rowHeight={30}
							rowData={rowData}
							animateRows={true}
							defaultColDef={defaultColDef}
							columnDefs={columnDefs}>
						</AgGridReact>
					</div>
				</CCol>
				<CCol xs={5}>
					<CForm>
						<CRow>
							<CCol xs={12}>
								<CInputGroup className={"mb-1"} size={"sm"}>
									<CInputGroupText style={{width: 100}}>메뉴코드</CInputGroupText>
									<CFormInput id="menuCd" value={selectedRow.menuCd}
												maxLength={10}
												onChange={(e) => {
													setSelectedRow((state) => ({
														...state,
														menuCd: e.target.value
													}))
												}}/>
								</CInputGroup>
							</CCol>
						</CRow>
						<CRow>
							<CCol xs={12}>
								<CInputGroup className={"mb-1"} size={"sm"}>
									<CInputGroupText style={{width: 100}}>메뉴명</CInputGroupText>
									<CFormInput id="menuNm" value={selectedRow.menuNm}
												maxLength={10}
												onChange={(e) => {
													setSelectedRow((state) => ({
														...state,
														menuNm: e.target.value
													}))
												}}/>
								</CInputGroup>
							</CCol>
						</CRow>
						<CRow>
							<CCol xs={12}>
								<CInputGroup className={"mb-1"} size={"sm"}>
									<CInputGroupText style={{width: 100}}>상위메뉴코드</CInputGroupText>
									<CFormInput id="parentCd" value={selectedRow.parentCd ? selectedRow.parentCd : ""}
												maxLength={10}
												onChange={(e) => {
													setSelectedRow((state) => ({
														...state,
														parentCd: e.target.value
													}))
												}}/>
								</CInputGroup>
							</CCol>
						</CRow>
						<CRow>
							<CCol xs={12}>
								<CInputGroup className={"mb-1"} size={"sm"}>
									<CInputGroupText style={{width: 100}}>메뉴경로</CInputGroupText>
									<CFormInput id="menuPath" value={selectedRow.menuPath ? selectedRow.menuPath : ""}
												onChange={(e) => {
													setSelectedRow((state) => ({
														...state,
														menuPath: e.target.value
													}))
												}}/>
								</CInputGroup>
							</CCol>
						</CRow>
						<CRow>
							<CCol xs={12}>
								<CInputGroup className={"mb-1"} size={"sm"}>
									<CInputGroupText style={{width: 100}}>메뉴권한</CInputGroupText>
									<CFormInput id="menuType" value={selectedRow.menuType}
												maxLength={10}
												onChange={(e) => {
													setSelectedRow((state) => ({
														...state,
														menuType: e.target.value
													}))
												}}/>
								</CInputGroup>
							</CCol>
						</CRow>
						<CRow>
							<CCol xs={6}>
								<CInputGroup className={"mb-1"} size={"sm"}>
									<CInputGroupText style={{width: 100}}>정렬순서</CInputGroupText>
									<CFormInput id="sortOrder" value={selectedRow.sortOrder}
												onChange={(e) => {
													setSelectedRow((state) => ({
														...state,
														sortOrder: e.target.value
													}))
												}}/>
								</CInputGroup>
							</CCol>
							<CCol xs={6}>
								<CInputGroup className={"mb-1"} size={"sm"}>
									<CInputGroupText style={{width: 100}}>사용유무</CInputGroupText>
									<CFormInput id="useYn" value={selectedRow.useYn}
												onChange={(e) => {
													setSelectedRow((state) => ({
														...state,
														useYn: e.target.value
													}))
												}}/>
								</CInputGroup>
							</CCol>
						</CRow>
						<div className="d-grid gap-1" style={{marginTop: 10}}>
							<CButton size={"sm"} onClick={save}>저장</CButton>
						</div>
					</CForm>
				</CCol>
			</CRow>
		</div>
	)
}

const mapStateToProps = (state) => {
	const {account, store, selected} = state;
	return {
		account, store, selected
	};
};

export default connect(mapStateToProps, null)(MenuManage);
